export const communityTranslations = {
  community_hero: {
    badge: "The Quality Nexus Community Platform",
    title: "Where software testers connect, learn and grow",
    description: "Profiles, a social feed, discussions, mentorship, study groups, roadmaps, tools, events and a QA jobs board — everything for your testing career in one platform.",
    createProfile: "Create your profile",
    exploreCommunity: "Explore the platform",
  },
  features: {
    title: "Everything inside the platform",
    description: "These are the features live in the community today — built specifically around how testing professionals work and learn.",
    modules: {
      profiles: { title: "Professional Profiles", description: "Skills, experience, certifications and portfolio in one QA-focused profile." },
      feed: { title: "Social Feed", description: "Post updates, share wins and keep up with what testers are working on." },
      discussions: { title: "Discussions", description: "Threaded Q&A where the community answers real testing problems." },
      connections: { title: "Connections & Messaging", description: "Follow testers, grow your network and chat one-to-one." },
      mentorship: { title: "Mentorship", description: "Find a mentor, become one, and use curated mentorship resources." },
      groups: { title: "Study Groups", description: "Learn together in small groups focused on a tool, skill or certification." },
      roadmaps: { title: "Learning Roadmaps", description: "Step-by-step paths for automation, performance, security and more." },
      tools: { title: "Tools Directory", description: "Browse and compare testing tools with community insight." },
      events: { title: "Events & Meetups", description: "Create, discover and join webinars, workshops and community meetups." },
      jobs: { title: "QA Jobs Board", description: "Testing roles shared by companies and members of the community." },
    },
  },
  deepDive: {
    title: "How members use the community",
    description: "From building your profile to landing your next role, here is how the platform supports each stage of your QA journey.",
    tabs: {
      profiles: {
        label: "Profiles", title: "Showcase your testing expertise",
        description: "Create a complete QA profile with your skills, experience, certifications and portfolio, then get discovered by peers and hiring teams in the Testers directory.",
        points: ["Skills, experience and certification sections built for QA", "Public profile page with portfolio and activity", "Discoverable in the community Testers directory"],
        cta: "Create your profile",
      },
      networking: {
        label: "Feed & Network", title: "Stay connected with the testing community",
        description: "A social feed, threaded discussions, connections and direct messaging keep you close to the people solving the same problems you are.",
        points: ["Post updates and react to what other testers share", "Ask questions in threaded discussions and get answers", "Send connection requests and chat in direct messages"],
        cta: "Explore the feed",
      },
      learning: {
        label: "Learning", title: "Grow with mentorship, groups and roadmaps",
        description: "Structured mentorship, study groups and learning roadmaps give you a clear path from where you are to where you want to be in QA.",
        points: ["Match with mentors and access mentorship resources", "Join or create study groups around a skill or certification", "Follow learning roadmaps and track your progress"],
        cta: "Browse roadmaps",
      },
      opportunities: {
        label: "Opportunities", title: "Tools, events and QA jobs in one place",
        description: "Discover the tools testers actually use, join community events, and find your next testing role — all inside the platform.",
        points: ["Tools directory with details on each testing tool", "Events and meetups you can attend or host", "QA jobs board with roles from the community"],
        cta: "Explore opportunities",
      },
    },
  },
  stats: { members: "Community members", discussions: "Discussions started", mentors: "Active mentors", jobs: "QA roles shared" },
  joinCTA: {
    title: "Ready to join the Quality Nexus Community?",
    description: "Create your profile, join the conversation, find a mentor and take the next step in your testing career.",
    action: "Create your profile",
    mentorAction: "Become a mentor",
  },
};
